/**
 * User ID used for temporary/unauthenticated resumes created on the free access builder route.
 * These resumes are not persisted to the database and are stored in localStorage instead.
 */
export const TEMPORARY_USER_ID = "temp" as const;

export const isTemporaryResume = (userId: string | undefined): boolean => {
  return userId === TEMPORARY_USER_ID;
};

